import React from 'react'

const DigitalLeftBody = () => {
  return (
    <div className='flex flex-col space-y-6'>
      <p className='font-poppin-thin font-medium font-sm text-justify'>Digital Transformation is all about redefining processes and finding better ways to do business. The most straightforward gain from going down this path is saving resources and time.</p>
      <p className='font-poppin-thin font-medium font-sm text-justify'>Free your employees time by automating mundane tasks with the right technology solutions, and you will unlock their creative potential. They can help you discover business opportunities you didn't know existed and unlock new revenue streams.</p>
    </div>
  )
}

export default DigitalLeftBody